import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { setError } from 'slices/departmentSlice';
import { updateDepartment } from 'slices/departmentSlice';
import { addDepartment } from 'slices/departmentSlice';
import { fetchDepartmentsList } from 'slices/departmentSlice';
import { departmentsSelector } from 'slices/departmentSlice';

const apiService = new Api();
const AddDepartmentForm = ({ item, handleClose, callback, show, statusPerm, userId }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, reset } = useForm();
  const { error, loader } = useSelector(departmentsSelector);
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    setValue('name', item?.user?.name || '')
    setValue('email', item?.user?.email || '')
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    dispatch(setError({}))
  }, [item])
  console.log("error", error);

  const ResetField = () => {
    reset({
      name: "",
      email: "",
      password: "",
      status: ""
    })
  }

  useEffect(() => {
    dispatch(setError({}))
    !show && ResetField();
    return () => ResetField()
  }, [show])

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      handleClose()
      ResetField()
      setButtonLoader(false)
      dispatch(fetchDepartmentsList(1, { location_id: userId }))
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
      setTimeout(() => {
        setButtonLoader(false)
      }, 1000);
    }
  };

  const onSubmit = (data) => {
    setButtonLoader(true);
    const formData = {
      ...data,
      location_id: userId,
    }

    if (item?.id) {
      dispatch(updateDepartment(formData, item?.id, submitCallback, true));
    }
    else
      dispatch(addDepartment(formData, submitCallback, true));

  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='theme_form'>
        <div className="row-primary row_secondary flex-basis-full">
          <h2>Department Name *</h2>
          <div className='w-100'>
            <Controller
              name="name"
              rules={{
                required: "Hospital name is required"
              }}
              control={control}
              render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Name' {...field} />}
            />
            {error?.errors?.name && (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error?.errors?.name } />
              </div>
            )}
            {errors?.name?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.name?.message} />
              </div>
            }
          </div>
        </div>

        <div className="row-primary row_secondary flex-basis-full">
          <h2>Email *</h2>
          <div className='w-100'>
            <Controller
              name="email"
              rules={{
                required: "Email is required"
              }}
              control={control}
              render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" autoComplete="off" name='email'
                pattern={
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                }
                placeholder="Email Address"
                {...field}
              />
              }
            />
            {error?.errors?.email?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
            {errors?.email?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.email?.message} />
              </div>
            }
          </div>
        </div>

        <div className="row-primary row_secondary flex-basis-full">
          <h2>Password {!item && '*'}</h2>
          <div className='w-100'>
            <Controller
              name="password"
              rules={!item ? {
                required: "Email is required"
              } : {}}
              control={control}
              render={({ field }) =>
                <input className={`input-in type_inp `} autoComplete="off" type="password" name='password' placeholder="Password" {...field}
                  disabled={watch("type") == "interpreter" ? true : false}
                />}
            />
            {error?.errors?.password?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
            {errors?.password?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.password?.message} />
              </div>
            }
          </div>
        </div>
      </div>

      {statusPerm &&
        <div className="row-primary m-0 align-items-center">
          <h2 className='mt-0'>Status</h2>
          <Controller name="status" control={control} required
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
            )}
          />
        </div>
      }


      <div className="Form-footer">
        <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" className="main_button">

          {buttonLoader ?
            <>
              <Spinner size="sm">
                Loading...
              </Spinner>

              <span>
                {' '}Loading
              </span>
            </>
            :
            <span>
              {item?.id ? "Update" : "Create"}
            </span>
          }
        </button>
      </div>
    </form>
  )
}

const AddDepartment = ({ item, onClose, callback, show, statusPerm, userId }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Department</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddDepartmentForm item={item} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} userId={userId} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddDepartment
